import React from "react";

/**
 * Stylized 90s loyalty card visual.
 * Pure CSS/JSX — no external image.
 */
export const FrdmBucksCard = ({ tilt = -6, size = "lg" }) => {
  const sizeClass =
    size === "lg" ? "w-[88vw] max-w-[520px] h-[320px]" : "w-[260px] h-[160px]";

  return (
    <div
      data-testid="frdmbucks-card"
      style={{ transform: `rotate(${tilt}deg)` }}
      className={`relative ${sizeClass} select-none`}
    >
      {/* Shadow / offset block */}
      <div
        aria-hidden
        className="absolute inset-0 translate-x-3 translate-y-3 bg-navy"
      />
      {/* Card body */}
      <div className="absolute inset-0 bg-red text-bone p-6 md:p-8 border-4 border-navy flex flex-col justify-between">
        <div className="flex justify-between items-start">
          <div>
            <p className="font-mono uppercase tracking-[0.3em] text-[10px] md:text-xs text-bone/90">
              FREEDOM COFFEE
            </p>
            <h3 className="font-display uppercase text-4xl md:text-6xl leading-[0.9] tracking-tight mt-1">
              FrdmBucks
            </h3>
          </div>
          <div className="text-right">
            <p className="font-mono uppercase tracking-[0.25em] text-[10px]">
              MEMBER
            </p>
            <p className="font-mono uppercase tracking-[0.25em] text-[10px] text-bone/70 mt-1">
              EST. 2026
            </p>
          </div>
        </div>

        {/* Halftone band */}
        <div className="absolute left-0 right-0 top-1/2 -translate-y-1/2 h-12 halftone opacity-30" />

        {/* Stripe band */}
        <div className="absolute right-6 top-1/2 -translate-y-1/2 w-2 h-24 bg-bone" />
        <div className="absolute right-12 top-1/2 -translate-y-1/2 w-1 h-24 bg-bone/60" />

        <div className="flex justify-between items-end relative z-10">
          <p className="font-mono uppercase tracking-[0.3em] text-[10px]">
            ◢◢ FREE REFILLS
          </p>
          <p className="font-display uppercase text-2xl md:text-3xl tracking-wider">
            ★ ★ ★ ★
          </p>
        </div>
      </div>
    </div>
  );
};

export default FrdmBucksCard;
